export * from './badge-status-cabecalho-pedido-de-carga.pipe';
